import { TFunction } from 'react-i18next';
import * as Yup from 'yup';
import { Shape } from '../../yup_types';

export enum QUICK_APPLICATION_FORM_FIELDS {
  COMPANY_NAME = 'LegalEntityName',
  DBA = 'Dba',
  ANNUAL_SALES_VOLUME = 'AnnualSalesVolume',
  DECLINE_RATE = 'DeclineRate',

  FIRST_NAME = 'PrimaryContactFirstName',
  LAST_NAME = 'PrimaryContactLastName',
  EMAIL = 'PrimaryContactEmail',
  PHONE = 'PrimaryContactPhone',
  ACCOUNT_MANAGER = 'AccountManagerId',
  INTEGRATION_PARTNER = 'IntegrationPartnerId',
  PARTNER = 'PartnerId',
  SALES_AGENCY = 'SalesAgencyId',
  INTEGRATION_TIER = 'IntegrationTier',
  CRM_ID = 'crmId',
  EXTERNAL_MERCHANT_IDENTIFIER = 'externalMerchantIdentifier',

  TERMS_AND_CONDITIONS = 'SpecialTerms',

  FEE_PERCENTAGE = 'percentage',
  FEE_AMOUNT = 'feeAmount',
  MIN_FEE_AMOUNT = 'minFeeAmount',
  CHARGEBACK = 'chargeback',
  REFUND_FEE = 'refundFee',
  RISK_FEE = 'riskFee',
  FEE_PERCENTAGE_ID = 'percentageId',
  FEE_AMOUNT_ID = 'feeAmountId',
  CHARGEBACK_ID = 'chargebackId',
  REFUND_FEE_ID = 'refundFeeId',
  RISK_FEE_ID = 'riskFeeId',
  CONTRACT_ALREADY_SIGNED = 'contractAlreadySigned',
  INTEGRATION_PARTNER_PARTICIPATE_SALE = 'integrationPartnerParticipateSale'
}

export enum QUICK_APPLICATION_FORM_FIELDS_NAMES {
  COMPANY_NAME = 'NEW_APPLICATION.LABEL.COMPANY_NAME',
  DBA = 'NEW_APPLICATION.LABEL.DOING_BUSINESS',
  ANNUAL_SALES_VOLUME = 'NEW_APPLICATION.LABEL.ANNUAL_SALES_VOLUME',
  DECLINE_RATE = 'NEW_APPLICATION.LABEL.DECLINE_RATE',

  FIRST_NAME = 'NEW_APPLICATION.LABEL.FIRST_NAME',
  LAST_NAME = 'NEW_APPLICATION.LABEL.LAST_NAME',
  EMAIL = 'NEW_APPLICATION.LABEL.EMAIL',
  PHONE = 'NEW_APPLICATION.LABEL.PHONE',
  ACCOUNT_MANAGER = 'NEW_APPLICATION.LABEL.ACCOUNT_MANAGER',
  INTEGRATION_PARTNER = 'NEW_APPLICATION.LABEL.INTEGRATION_PARTNER',
  PARTNER = 'NEW_APPLICATION.LABEL.PARTNER_ID',
  SALES_AGENCY = 'NEW_APPLICATION.LABEL.SALES_AGENCY',
  INTEGRATION_TIER = 'NEW_APPLICATION.LABEL.INTEGRATION_TIER',
  CRM_ID = 'NEW_APPLICATION.LABEL.CRM_ID',
  EXTERNAL_MERCHANT_IDENTIFIER = 'NEW_APPLICATION.LABEL.EXTERNAL_MERCHANT_IDENTIFIER',

  TERMS_AND_CONDITIONS = 'NEW_APPLICATION.LABEL.SPECIAL_TERMS',

  FEE_PERCENTAGE = 'FEES.PERCENTAGE',
  FEE_AMOUNT = 'FEES.FEE_AMOUNT',
  MIN_FEE_AMOUNT = 'FEES.MIN_FEE_AMOUNT',
  CHARGEBACK = 'FEES.CHARGEBACK',
  REFUND_FEE = 'FEES.REFUND_FEE',
  RISK_FEE = 'FEES.RISK_FEE',
  FEE_PERCENTAGE_TOOLTIP = 'FEES.PERCENTAGE_TOOLTIP',
  FEE_AMOUNT_TOOLTIP = 'FEES.FEE_AMOUNT_TOOLTIP',
  MIN_FEE_AMOUNT_TOOLTIP = 'FEES.MIN_FEE_AMOUNT_TOOLTIP',
  CHARGEBACK_TOOLTIP = 'FEES.CHARGEBACK_TOOLTIP',
  REFUND_FEE_TOOLTIP = 'FEES.REFUND_FEE_TOOLTIP',
  RISK_FEE_TOOLTIP = 'FEES.RISK_FEE_TOOLTIP',
  CONTRACT_ALREADY_SIGNED = 'NEW_APPLICATION.LABEL.CONTRACT_ALREADY_SIGNED',
  INTEGRATION_PARTNER_PARTICIPATE_SALE = 'NEW_APPLICATION.LABEL.INTEGRATION_PARTNER_PARTICIPATE_SALE',

}

export interface QuickApplicationTypes extends IFeeForm {
  [QUICK_APPLICATION_FORM_FIELDS.COMPANY_NAME]: string;
  [QUICK_APPLICATION_FORM_FIELDS.DBA]: string;
  [QUICK_APPLICATION_FORM_FIELDS.ANNUAL_SALES_VOLUME]: string | number;
  [QUICK_APPLICATION_FORM_FIELDS.DECLINE_RATE]: string | number;

  [QUICK_APPLICATION_FORM_FIELDS.FIRST_NAME]: string;
  [QUICK_APPLICATION_FORM_FIELDS.LAST_NAME]: string;
  [QUICK_APPLICATION_FORM_FIELDS.EMAIL]: string;
  [QUICK_APPLICATION_FORM_FIELDS.PHONE]: string | number;
  [QUICK_APPLICATION_FORM_FIELDS.ACCOUNT_MANAGER]?: string;
  [QUICK_APPLICATION_FORM_FIELDS.INTEGRATION_PARTNER]: string;
  [QUICK_APPLICATION_FORM_FIELDS.PARTNER]: string;
  [QUICK_APPLICATION_FORM_FIELDS.SALES_AGENCY]: string;
  [QUICK_APPLICATION_FORM_FIELDS.INTEGRATION_TIER]: string;

  [QUICK_APPLICATION_FORM_FIELDS.TERMS_AND_CONDITIONS]: string;
  [QUICK_APPLICATION_FORM_FIELDS.CONTRACT_ALREADY_SIGNED]: boolean;
  [QUICK_APPLICATION_FORM_FIELDS.INTEGRATION_PARTNER_PARTICIPATE_SALE]: boolean;
  [QUICK_APPLICATION_FORM_FIELDS.CRM_ID]: string;
  [QUICK_APPLICATION_FORM_FIELDS.EXTERNAL_MERCHANT_IDENTIFIER]: string;
}

export interface IFeeForm {
  [QUICK_APPLICATION_FORM_FIELDS.FEE_PERCENTAGE]?: string | number;
  [QUICK_APPLICATION_FORM_FIELDS.FEE_AMOUNT]?: string | number;
  [QUICK_APPLICATION_FORM_FIELDS.MIN_FEE_AMOUNT]?: string | number;
  [QUICK_APPLICATION_FORM_FIELDS.CHARGEBACK]?: string | number;
  [QUICK_APPLICATION_FORM_FIELDS.REFUND_FEE]?: string | number;
  [QUICK_APPLICATION_FORM_FIELDS.RISK_FEE]?: string | number;
  [QUICK_APPLICATION_FORM_FIELDS.FEE_PERCENTAGE_ID]?: string;
  [QUICK_APPLICATION_FORM_FIELDS.FEE_AMOUNT_ID]?: string;
  [QUICK_APPLICATION_FORM_FIELDS.CHARGEBACK_ID]?: string;
  [QUICK_APPLICATION_FORM_FIELDS.REFUND_FEE_ID]?: string;
  [QUICK_APPLICATION_FORM_FIELDS.RISK_FEE_ID]?: string;
}

export interface QuickApplicationFormReturnTypes {
  legalEntityName: string;
  dba: string;
  annualSalesVolume: number;
  declineRate?: number;

  primaryContact: {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
  }
  accountManagerId: string;
  integrationPartnerId: string;
  partnerId: string;
  salesAgencyId: string;
  integrationTier: string;

  specialTerms: string;

  resendForReview?: boolean;
  send?: boolean;
  contractAlreadySigned: boolean;
  integrationPartnerParticipateSale: boolean;
  crmId?: string;
  externalMerchantIdentifier?: string;
}

export const getQuickApplicationInitialValues = ({ partnerId, integrationPartnerId }): QuickApplicationTypes => ({
  [QUICK_APPLICATION_FORM_FIELDS.COMPANY_NAME]: '',
  [QUICK_APPLICATION_FORM_FIELDS.DBA]: '',
  [QUICK_APPLICATION_FORM_FIELDS.ANNUAL_SALES_VOLUME]: '',
  [QUICK_APPLICATION_FORM_FIELDS.DECLINE_RATE]: '',

  [QUICK_APPLICATION_FORM_FIELDS.FIRST_NAME]: '',
  [QUICK_APPLICATION_FORM_FIELDS.LAST_NAME]: '',
  [QUICK_APPLICATION_FORM_FIELDS.EMAIL]: '',
  [QUICK_APPLICATION_FORM_FIELDS.PHONE]: '',
  [QUICK_APPLICATION_FORM_FIELDS.ACCOUNT_MANAGER]: '',
  [QUICK_APPLICATION_FORM_FIELDS.INTEGRATION_PARTNER]: integrationPartnerId || '',
  [QUICK_APPLICATION_FORM_FIELDS.PARTNER]: partnerId || '',
  [QUICK_APPLICATION_FORM_FIELDS.SALES_AGENCY]: '',
  [QUICK_APPLICATION_FORM_FIELDS.INTEGRATION_TIER]: '',

  [QUICK_APPLICATION_FORM_FIELDS.TERMS_AND_CONDITIONS]: '',

  [QUICK_APPLICATION_FORM_FIELDS.FEE_PERCENTAGE]: '',
  [QUICK_APPLICATION_FORM_FIELDS.FEE_AMOUNT]: '',
  [QUICK_APPLICATION_FORM_FIELDS.MIN_FEE_AMOUNT]: '',
  [QUICK_APPLICATION_FORM_FIELDS.CHARGEBACK]: '',
  [QUICK_APPLICATION_FORM_FIELDS.REFUND_FEE]: '',
  [QUICK_APPLICATION_FORM_FIELDS.RISK_FEE]: '',
  [QUICK_APPLICATION_FORM_FIELDS.FEE_PERCENTAGE_ID]: '',
  [QUICK_APPLICATION_FORM_FIELDS.FEE_AMOUNT_ID]: '',
  [QUICK_APPLICATION_FORM_FIELDS.CHARGEBACK_ID]: '',
  [QUICK_APPLICATION_FORM_FIELDS.REFUND_FEE_ID]: '',
  [QUICK_APPLICATION_FORM_FIELDS.RISK_FEE_ID]: '',
  [QUICK_APPLICATION_FORM_FIELDS.CONTRACT_ALREADY_SIGNED]: false,
  [QUICK_APPLICATION_FORM_FIELDS.INTEGRATION_PARTNER_PARTICIPATE_SALE]: false,
  [QUICK_APPLICATION_FORM_FIELDS.CRM_ID]: '',
  [QUICK_APPLICATION_FORM_FIELDS.EXTERNAL_MERCHANT_IDENTIFIER]: '',
});

// @ts-ignore
export const getPartnerQuickApplicationValidationSchema = (t: TFunction): Yup.SchemaOf<QuickApplicationTypes> => Yup.object<Shape<QuickApplicationTypes>>().shape({
  [QUICK_APPLICATION_FORM_FIELDS.FIRST_NAME]: Yup.string()
    .required(t('NEW_APPLICATION.VALIDATION.FIRST_NAME_REQUIRED')),
  [QUICK_APPLICATION_FORM_FIELDS.LAST_NAME]: Yup.string()
    .required(t('NEW_APPLICATION.VALIDATION.LAST_NAME_REQUIRED')),
  [QUICK_APPLICATION_FORM_FIELDS.EMAIL]: Yup.string()
    .email(t('NEW_APPLICATION.VALIDATION.EMAIL_ERROR_TEXT'))
    .required(t('NEW_APPLICATION.VALIDATION.EMAIL_REQUIRED')),
  [QUICK_APPLICATION_FORM_FIELDS.PHONE]: Yup.number()
    .test('is-valid-phone', t('NEW_APPLICATION.VALIDATION.VALID_PHONE'), (value) => {
      if (!value) return true;
      const phoneRegex = /^[0-9]{10,15}$/;
      return phoneRegex.test(value.toString());
    })
    .required(t('NEW_APPLICATION.VALIDATION.PHONE_REQUIRED')),
  // [QUICK_APPLICATION_FORM_FIELDS.ACCOUNT_MANAGER]: Yup.string()
  //   .required(t('NEW_APPLICATION.VALIDATION.ACCOUNT_MANAGER_REQUIRED')),
  // [QUICK_APPLICATION_FORM_FIELDS.PARTNER]: Yup.string()
  //   .required(t('NEW_APPLICATION.VALIDATION.PARTNER_ID_REQUIRED')),
  [QUICK_APPLICATION_FORM_FIELDS.INTEGRATION_PARTNER]: Yup.string(),
    // .required(t('NEW_APPLICATION.VALIDATION.INTEGRATION_PARTNER_REQUIRED')),
  [QUICK_APPLICATION_FORM_FIELDS.SALES_AGENCY]: Yup.string(),
  [QUICK_APPLICATION_FORM_FIELDS.INTEGRATION_TIER]: Yup.string()
    .required(t('NEW_APPLICATION.VALIDATION.INTEGRATION_TIER_REQUIRED')),
  [QUICK_APPLICATION_FORM_FIELDS.DBA]: Yup.string()
    .required(t('NEW_APPLICATION.VALIDATION.DOING_BUSINESS_REQUIRED')),
    [QUICK_APPLICATION_FORM_FIELDS.ANNUAL_SALES_VOLUME]: Yup.number()
        .min(0, t('NEW_APPLICATION.VALIDATION.MIN_VALUE'))
    .required(t('NEW_APPLICATION.VALIDATION.ANNUAL_SALES_VOLUME_REQUIRED')),
  [QUICK_APPLICATION_FORM_FIELDS.DECLINE_RATE]: Yup.number()
    .min(0, t('NEW_APPLICATION.VALIDATION.MIN_VALUE'))
    .max(100, t('NEW_APPLICATION.VALIDATION.MAX_VALUE')),
  [QUICK_APPLICATION_FORM_FIELDS.TERMS_AND_CONDITIONS]: Yup.string(),
  [QUICK_APPLICATION_FORM_FIELDS.COMPANY_NAME]: Yup.string()
    .required(t('NEW_APPLICATION.VALIDATION.COMPANY_NAME_REQUIRED')),

  [QUICK_APPLICATION_FORM_FIELDS.FEE_PERCENTAGE]: Yup.number()
    .required(t('FEES.VALIDATION.FEE_PERCENTAGE_REQUIRED'))
    .min(0, t('FEES.VALIDATION.MIN_VALUE'))
    .max(100, t('FEES.VALIDATION.MAX_VALUE')),
  [QUICK_APPLICATION_FORM_FIELDS.FEE_AMOUNT]: Yup.number()
    .required(t('FEES.VALIDATION.FEE_AMOUNT_REQUIRED'))
    .min(0, t('FEES.VALIDATION.MIN_VALUE')),
  [QUICK_APPLICATION_FORM_FIELDS.MIN_FEE_AMOUNT]: Yup.number()
    .required(t('FEES.VALIDATION.MIN_FEE_AMOUNT_REQUIRED'))
    .min(0, t('FEES.VALIDATION.MIN_VALUE')),
  [QUICK_APPLICATION_FORM_FIELDS.CHARGEBACK]: Yup.number()
    .required(t('FEES.VALIDATION.CHARGEBACK_REQUIRED'))
    .min(0, t('FEES.VALIDATION.MIN_VALUE')),
  [QUICK_APPLICATION_FORM_FIELDS.REFUND_FEE]: Yup.number()
    .required(t('FEES.VALIDATION.REFUND_FEE_REQUIRED'))
    .min(0, t('FEES.VALIDATION.MIN_VALUE')),
  [QUICK_APPLICATION_FORM_FIELDS.RISK_FEE]: Yup.number()
    .required(t('FEES.VALIDATION.RISK_FEE_REQUIRED'))
    .min(0, t('FEES.VALIDATION.MIN_VALUE'))
    .max(100, t('FEES.VALIDATION.MAX_VALUE')),
  [QUICK_APPLICATION_FORM_FIELDS.FEE_PERCENTAGE_ID]: Yup.string(),
  [QUICK_APPLICATION_FORM_FIELDS.FEE_AMOUNT_ID]: Yup.string(),
  [QUICK_APPLICATION_FORM_FIELDS.CHARGEBACK_ID]: Yup.string(),
  [QUICK_APPLICATION_FORM_FIELDS.REFUND_FEE_ID]: Yup.string(),
  [QUICK_APPLICATION_FORM_FIELDS.RISK_FEE_ID]: Yup.string(),
  [QUICK_APPLICATION_FORM_FIELDS.CRM_ID]: Yup.string(),
  [QUICK_APPLICATION_FORM_FIELDS.EXTERNAL_MERCHANT_IDENTIFIER]: Yup.string(),

});

export const getAdminQuickApplicationValidationSchema = (t: TFunction): Yup.SchemaOf<QuickApplicationTypes> => Yup.object<Shape<QuickApplicationTypes>>().shape({
  ...getPartnerQuickApplicationValidationSchema(t).fields,
  [QUICK_APPLICATION_FORM_FIELDS.ACCOUNT_MANAGER]: Yup.string(),
    // .required(t('NEW_APPLICATION.VALIDATION.ACCOUNT_MANAGER_REQUIRED')),
  [QUICK_APPLICATION_FORM_FIELDS.PARTNER]: Yup.string()
    .required(t('NEW_APPLICATION.VALIDATION.PARTNER_ID_REQUIRED')),
});

export const convertQuickApplicationToInitialValues = (data): QuickApplicationTypes => ({
  [QUICK_APPLICATION_FORM_FIELDS.COMPANY_NAME]: data?.legalEntityName ? data?.legalEntityName : '',
  [QUICK_APPLICATION_FORM_FIELDS.DBA]: data?.dba ? data?.dba : '',
  [QUICK_APPLICATION_FORM_FIELDS.ANNUAL_SALES_VOLUME]: data?.annualSalesVolume ? data?.annualSalesVolume : null,
  [QUICK_APPLICATION_FORM_FIELDS.DECLINE_RATE]: data?.declineRate ? data?.declineRate : '',

  [QUICK_APPLICATION_FORM_FIELDS.FIRST_NAME]: data?.primaryContact?.firstName ? data?.primaryContact?.firstName : '',
  [QUICK_APPLICATION_FORM_FIELDS.LAST_NAME]: data?.primaryContact?.lastName ? data?.primaryContact?.lastName : '',
  [QUICK_APPLICATION_FORM_FIELDS.EMAIL]: data?.primaryContact?.email ? data?.primaryContact?.email : '',
  [QUICK_APPLICATION_FORM_FIELDS.PHONE]: data?.primaryContact?.phone ? data?.primaryContact?.phone : '',
  [QUICK_APPLICATION_FORM_FIELDS.ACCOUNT_MANAGER]: data?.accountManagerId ? data?.accountManagerId : '',
  [QUICK_APPLICATION_FORM_FIELDS.INTEGRATION_PARTNER]: data?.integrationPartnerId ? data?.integrationPartnerId : '',
  [QUICK_APPLICATION_FORM_FIELDS.PARTNER]: data?.partnerId ? data?.partnerId : '',
  [QUICK_APPLICATION_FORM_FIELDS.SALES_AGENCY]: data?.salesAgencyId ? data?.salesAgencyId : '',
  [QUICK_APPLICATION_FORM_FIELDS.INTEGRATION_TIER]: data?.integrationTier ? data?.integrationTier : '',

  [QUICK_APPLICATION_FORM_FIELDS.TERMS_AND_CONDITIONS]: data?.specialTerms ? data?.specialTerms : '',
   [QUICK_APPLICATION_FORM_FIELDS.CONTRACT_ALREADY_SIGNED]: data?.contractAlreadySigned ? data?.contractAlreadySigned : false,
    [QUICK_APPLICATION_FORM_FIELDS.INTEGRATION_PARTNER_PARTICIPATE_SALE]: data?.integrationPartnerParticipateSale ? data?.integrationPartnerParticipateSale : false,
    [QUICK_APPLICATION_FORM_FIELDS.CRM_ID]: data?.crmId ? data?.crmId : '',
    [QUICK_APPLICATION_FORM_FIELDS.EXTERNAL_MERCHANT_IDENTIFIER]: data?.externalMerchantIdentifier ? data?.externalMerchantIdentifier : '',
});

export const formattedQuickApplicationFormValues = (formikValues): QuickApplicationFormReturnTypes => ({
  primaryContact: {
    firstName: formikValues?.[QUICK_APPLICATION_FORM_FIELDS.FIRST_NAME],
    lastName: formikValues?.[QUICK_APPLICATION_FORM_FIELDS.LAST_NAME],
    email: formikValues?.[QUICK_APPLICATION_FORM_FIELDS.EMAIL],
    phone: formikValues?.[QUICK_APPLICATION_FORM_FIELDS.PHONE],
  },
  accountManagerId: formikValues?.[QUICK_APPLICATION_FORM_FIELDS.ACCOUNT_MANAGER] || null,
  integrationPartnerId: formikValues?.[QUICK_APPLICATION_FORM_FIELDS.INTEGRATION_PARTNER] || null,
  partnerId: formikValues?.[QUICK_APPLICATION_FORM_FIELDS.PARTNER],
  salesAgencyId: formikValues?.[QUICK_APPLICATION_FORM_FIELDS.SALES_AGENCY] || null,
  integrationTier: formikValues?.[QUICK_APPLICATION_FORM_FIELDS.INTEGRATION_TIER],
  dba: formikValues?.[QUICK_APPLICATION_FORM_FIELDS.DBA],
  annualSalesVolume: formikValues?.[QUICK_APPLICATION_FORM_FIELDS.ANNUAL_SALES_VOLUME],
  declineRate: formikValues?.[QUICK_APPLICATION_FORM_FIELDS.DECLINE_RATE],
  specialTerms: formikValues?.[QUICK_APPLICATION_FORM_FIELDS.TERMS_AND_CONDITIONS],
  legalEntityName: formikValues?.[QUICK_APPLICATION_FORM_FIELDS.COMPANY_NAME],
  contractAlreadySigned: formikValues?.[QUICK_APPLICATION_FORM_FIELDS.CONTRACT_ALREADY_SIGNED],
  integrationPartnerParticipateSale: formikValues?.[QUICK_APPLICATION_FORM_FIELDS.INTEGRATION_PARTNER_PARTICIPATE_SALE] || false,
  crmId: formikValues?.[QUICK_APPLICATION_FORM_FIELDS.CRM_ID] || null,
  externalMerchantIdentifier: formikValues?.[QUICK_APPLICATION_FORM_FIELDS.EXTERNAL_MERCHANT_IDENTIFIER] || null,
});

export const getFormattedFormikFeeData = (formikValues): any => {
  return ({
    percentage: formikValues[QUICK_APPLICATION_FORM_FIELDS.FEE_PERCENTAGE] ? Number(formikValues[QUICK_APPLICATION_FORM_FIELDS.FEE_PERCENTAGE]) : null,
    feeAmount: formikValues[QUICK_APPLICATION_FORM_FIELDS.FEE_AMOUNT] ? Number(formikValues[QUICK_APPLICATION_FORM_FIELDS.FEE_AMOUNT]) : null,
    minFeeAmount: formikValues[QUICK_APPLICATION_FORM_FIELDS.MIN_FEE_AMOUNT] ? Number(formikValues[QUICK_APPLICATION_FORM_FIELDS.MIN_FEE_AMOUNT]) : null,
    chargeback: formikValues[QUICK_APPLICATION_FORM_FIELDS.CHARGEBACK] ? Number(formikValues[QUICK_APPLICATION_FORM_FIELDS.CHARGEBACK]) : null,
    refundFee: formikValues[QUICK_APPLICATION_FORM_FIELDS.REFUND_FEE] ? Number(formikValues[QUICK_APPLICATION_FORM_FIELDS.REFUND_FEE]) : null,
    riskFee: formikValues[QUICK_APPLICATION_FORM_FIELDS.RISK_FEE] ? Number(formikValues[QUICK_APPLICATION_FORM_FIELDS.RISK_FEE]) : null,
    percentageId: formikValues[QUICK_APPLICATION_FORM_FIELDS.FEE_PERCENTAGE_ID] || '',
    feeAmountId: formikValues[QUICK_APPLICATION_FORM_FIELDS.FEE_AMOUNT_ID] || '',
    chargebackId: formikValues[QUICK_APPLICATION_FORM_FIELDS.CHARGEBACK_ID] || '',
    refundFeeId: formikValues[QUICK_APPLICATION_FORM_FIELDS.REFUND_FEE_ID] || '',
    riskFeeId: formikValues[QUICK_APPLICATION_FORM_FIELDS.RISK_FEE_ID] || '',
    contractAlreadySigned: formikValues[QUICK_APPLICATION_FORM_FIELDS.CONTRACT_ALREADY_SIGNED] || false,
    integrationPartnerParticipateSale: formikValues[QUICK_APPLICATION_FORM_FIELDS.INTEGRATION_PARTNER_PARTICIPATE_SALE] || false,
  });
};

export const convertToInitialFeeValues = (data): IFeeForm => {
  return ({
    [QUICK_APPLICATION_FORM_FIELDS.FEE_PERCENTAGE]: data?.percentage,
    [QUICK_APPLICATION_FORM_FIELDS.FEE_AMOUNT]: data?.feeAmount,
    [QUICK_APPLICATION_FORM_FIELDS.MIN_FEE_AMOUNT]: data?.minFeeAmount,
    [QUICK_APPLICATION_FORM_FIELDS.CHARGEBACK]: data?.chargeback,
    [QUICK_APPLICATION_FORM_FIELDS.REFUND_FEE]: data?.refundFee,
    [QUICK_APPLICATION_FORM_FIELDS.RISK_FEE]: data?.riskFee,
    [QUICK_APPLICATION_FORM_FIELDS.FEE_PERCENTAGE_ID]: data?.percentageId,
    [QUICK_APPLICATION_FORM_FIELDS.FEE_AMOUNT_ID]: data?.feeAmountId,
    [QUICK_APPLICATION_FORM_FIELDS.CHARGEBACK_ID]: data?.chargebackId,
    [QUICK_APPLICATION_FORM_FIELDS.REFUND_FEE_ID]: data?.refundFeeId,
    [QUICK_APPLICATION_FORM_FIELDS.RISK_FEE_ID]: data?.riskFeeId,
  });
};
